// Ionic & Angular Imports
import {Component} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {Events, AlertController, PopoverController, ViewController, NavController,
        NavParams, LoadingController, Loading} from 'ionic-angular';

// Service Imports
import {rsReportSvc, ReportState} from '../../../../services/report.service';

// Component Imports
import {BasePage} from '../../../base.component';

@Component({
    templateUrl: 'notes.html',
})
export class NotesPage extends BasePage
{
    // Class member variables
    private modalForm       : FormGroup;
    private initNotes       : string;

    constructor( 
        protected alertCtrl : AlertController,
        private navCtrl : NavController,
        private navParams : NavParams, 
        private reportSvc: rsReportSvc, 
        private loadingCtrl : LoadingController,
        private viewCtrl : ViewController,
        private formBuilder : FormBuilder,
        private popupCtrl : PopoverController,
        private eventSystem : Events
    ){
        // Construct base class
        super( alertCtrl );

        // Retrieve modal data from NavParams           
        this.initNotes = <string>this.navParams.get("content");

        // Build our form model structure
        this.buildFormModel();
    }

    // Class method for builidng our form model structure 
    private buildFormModel() {
        this.modalForm = this.formBuilder.group({
            notes:      [this.initNotes]
        });
    }


    public modalReset() {
        this.modalForm.reset( {
            notes:      this.initNotes
        });
    }

    public modalSubmit( formData : any, isValid : boolean ) {
        // Display a loader while the modal submits our changes
        let loader : Loading = this.loadingCtrl.create({
            content: 'Updating...',
            dismissOnPageChange: true
        });
        loader.present().then( () => {
            // Determine what the submit button shoudl be doing based on the validity
            // of the form and the mode of the modal.
            if( isValid === true) {
                this.reportSvc.updateAdditionalNotes( this.reportSvc.getActiveReportId(), formData.notes ).subscribe( result => {
                    this.eventSystem.publish('report:updated', ReportState.AdditionalNotes, result );
                }, err => {
                    // Operation failed; dismiss loader and display an error message
                    loader.dismiss().then( () => {
                        this.displayError("There was an error updating the report.  Please try again later." );
                    });
                }, () => {
                    // Operation complete, let's navigate back
                    this.navCtrl.pop();
                });
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/pages/report/tab-main/notes/notes.component.ts